import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

function Card({ icon, title, description, descriptionSize, textPosition, children, fakeChildren }) {
  const position = textPosition ?? 'left';
  return (
    <div className="shadow-md px-4 py-2 h-full hover:scale-120 bg-white">
      <div className={`text-${position}`}>
        <div className={`text-${position}`}>
          <p className="text-accentColor font-bold text-xl">
            {icon && (
              <FontAwesomeIcon
                icon={icon}
                className="my-auto text-2xl mr-2"
              />
            )}
            {title}
          </p>
        </div>
        {description && (
          <p className={`mt-2 text-md ${descriptionSize}`}>{description}</p>
        )}
        {children}
        {fakeChildren ? (
          <div className="opacity-0">.</div>
        ) : (<></>)}
      </div>
    </div>
  );
}

export default Card;
